import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Category } from '../models/category.model';
import {
  QuestionDetail,
  QuestionFormModel,
} from '../models/question-detail.model';
import { QuestionDetailApi } from '../api/question-detail.api';

@Injectable({ providedIn: 'root' })
export class QuestionDetailService {
  private readonly _api = inject(QuestionDetailApi);

  public getById(id: number): Observable<QuestionDetail> {
    return this._api.getById(id);
  }

  public create(
    model: QuestionFormModel,
    categories: Category[],
  ): Observable<QuestionDetail> {
    return this._api.create(model, categories);
  }

  public update(
    id: number,
    model: QuestionFormModel,
    categories: Category[],
  ): Observable<void> {
    return this._api.update(id, model, categories);
  }

  public delete(id: number, locale?: string): Observable<void> {
    return this._api.delete(id, locale);
  }

  public categories(): Observable<Category[]> {
    return this._api.categories();
  }
}
